module.exports = __webpack_public_path__ + "static/img/logo3.2054cce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo3.png
// module id = 1253
// module chunks = 45